import React from "react";

const Loader = ({className}) => {
  return (
    <div className={className ? `${className} loader m-l-10` : `loader m-l-10`}/>
  );
};

export default Loader;
